export var TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';
export var TOGGLE_USER_MENU = 'TOGGLE_USER_MENU';
export var SET_ACTIVE_TAB = 'SET_ACTIVE_TAB';
export var SET_QUICKBET_MODAL = 'SET_QUICKBET_MODAL';
export var SET_COUPON_MODAL = 'SET_COUPON_MODAL';



// WEBPACK FOOTER //
// ./src/actions/sidebar.js